export default __webpack_public_path__ + "static/media/02.acd8601f.jpg";